export const NAVBAR_MOBILE_LIST = 'list'
export const NAVBAR_MOBILE_MAP = 'map'
export const NAVBAR_STICKY_DEFAULT = false
